import { Injectable } from '@angular/core';
import { MUser } from '@argalis-apps/models';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  constructor() {}

  checkProfileCompletion(user: MUser.IUser): boolean {
    return !!user && this.checkPersonalCompletion(user.userInfo) && this.checkSocietyCompletion(user.company);
  }

  checkPersonalCompletion(contact: MUser.IContact): boolean {
    return (
      !!contact.civ &&
      !!contact.name &&
      !!contact.firstName &&
      !!contact.role &&
      !!contact.phone &&
      !!contact.mobile &&
      !!contact.addr &&
      !!contact.addr.addr &&
      !!contact.addr.postal &&
      !!contact.addr.city &&
      !!contact.cgu
    );
  }

  checkSocietyCompletion(company: MUser.IClient): boolean {
    return (
      !!company.name &&
      (company.type !== null && company.type !== undefined) &&
      !!company.siren &&
      !!company.tva &&
      !!company.addr &&
      !!company.addr.addr &&
      !!company.addr.postal &&
      !!company.addr.city
    );
  }
}
